import React from "react";
import { useTranslate } from "app/translations";
import { selfKey } from "utilities/names";

export const Status = ({ historyData, isSelf }) => {
	const { _t } = useTranslate();
	const { before, after } = historyData;

	const slugifyStatus = (status) => {
		return status.toLowerCase().replace(" ", "_");
	};

	const status = (status) => {
		return (
			<strong className="text-sm text-primary-600">
				{_t(`ticket.category.status.${slugifyStatus(status)}`)}
			</strong>
		);
	};

	const renderDetails = () => {
		if (!before) {
			return (
				<p>
					{_t(selfKey("ticket.history.event.status.changed", isSelf)).toLowerCase()} {status(after)}
				</p>
			);
		} else {
			return (
				<p>
					{_t(selfKey("ticket.history.event.status.changedToFrom", isSelf)).toLowerCase()} {status(before)}{" "}
					{_t("to").toLowerCase()} {status(after)}
				</p>
			);
		}
	};

	return <div>{renderDetails()}</div>;
};
